import { Capacitor } from '@capacitor/core';

// True inside the iPhone / Android app, false in a browser.
export const isNative = Capacitor.isNativePlatform();

// The web app calls its API on the same origin. The native app is served from
// capacitor://localhost (iOS) / https://localhost (Android), so it has to call
// the live site. REACT_APP_NATIVE_API_ORIGIN points a dev build at a local API.
export const API_ORIGIN = isNative
  ? (process.env.REACT_APP_NATIVE_API_ORIGIN || 'https://clinicianscore.com')
  : '';
